/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadGeolocalisation
 */
export interface ReadGeolocalisation {
    /**
     * 
     * @type {string}
     * @memberof ReadGeolocalisation
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ReadGeolocalisation
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof ReadGeolocalisation
     */
    longitude: number;
    /**
     * 
     * @type {string}
     * @memberof ReadGeolocalisation
     */
    placeId: string;
}

/**
 * Check if a given object implements the ReadGeolocalisation interface.
 */
export function instanceOfReadGeolocalisation(value: object): value is ReadGeolocalisation {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('placeId' in value) || value['placeId'] === undefined) return false;
    return true;
}

export function ReadGeolocalisationFromJSON(json: any): ReadGeolocalisation {
    return ReadGeolocalisationFromJSONTyped(json, false);
}

export function ReadGeolocalisationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadGeolocalisation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'placeId': json['placeId'],
    };
}

export function ReadGeolocalisationToJSON(json: any): ReadGeolocalisation {
    return ReadGeolocalisationToJSONTyped(json, false);
}

export function ReadGeolocalisationToJSONTyped(value?: ReadGeolocalisation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'placeId': value['placeId'],
    };
}

